import styled from "styled-components";

export const AppContainer = styled.div`
max-width: 800px;
margin: 0 auto;
padding: 0 5%;
color: #222;
`;